export const AWARDING_TYPE_OPTIONS = [
  { value: 'STACK', label: 'Stack' },
  { value: 'TOPPER', label: 'Topper' },
];

export const FUND_TYPE_OPTIONS = [
  { value: 'GRANT', label: 'Grant' },
  { value: 'SCHOLARSHIP', label: 'Scholarship' },
  { value: 'WORKSTUDY', label: 'WorkStudy' },
  { value: 'LOAN', label: 'Loan' },
  { value: 'EMPLOYEE', label: 'Employee' },
];

export const FUND_SOURCE_OPTIONS = [
  { value: 'INSTITUTIONAL', label: 'Institutional' },
  { value: 'FEDERAL', label: 'Federal' },
  { value: 'STATE', label: 'State' },
  { value: 'OUTSIDE', label: 'Outside' },
];

export const FUND_TYPE_LABELS = {
  GRANT: 'Grant',
  SCHOLARSHIP: 'Scholarship',
  WORKSTUDY: 'WorkStudy',
  LOAN: 'Loan',
  EMPLOYEE: 'Employee',
};

export const FUND_SOURCE_LABELS = {
  INSTITUTIONAL: 'Institutional',
  FEDERAL: 'Federal',
  STATE: 'State',
  OUTSIDE: 'Outside',
};

export const BOOL_FILTER_OPTIONS = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
] as const;

export const DRAFT_STATUS = {
  CLEAN: 'clean',
  NEW: 'new',
  MODIFIED: 'modified',
  DELETED: 'deleted',
};
